<template>
  <b-overlay :show="isLoading" rounded="sm" :opacity="0.5">
    <div>
      <slot name="title-bar"></slot>
      <b-alert show variant="info" class="mt-3">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <b v-text="$lang.evidence_helper" />
      </b-alert>
      <b-form-group
        :label="$lang.evidence"
        label-for="evidence"
        :label-cols="this.$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.evidence_second_person"
          :rules="$v.evidence.$params"
        />
        <b-form-textarea
          id="evidence"
          type="text"
          v-model="$v.evidence.$model"
          :state="$v.evidence.$dirty ? !$v.evidence.$error : null"
          :autocomplete="$lang.evidence"
          :rows="this.$config.form.textareaRows"
        ></b-form-textarea>
        <b-form-invalid-feedback id="father_name-feedback"
          >{{ $lang.error_required | replace($lang.evidence) }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        :label="$lang.evidence_caption_third_person"
        label-for="evidence"
        :label-cols="this.$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.evidence_caption_third_person"
          :rules="$v.evidence_caption_third_person.$params"
        />
        <b-form-textarea
          id="evidence"
          type="text"
          v-model="$v.evidence_caption_third_person.$model"
          :state="
            $v.evidence_caption_third_person.$dirty
              ? !$v.evidence_caption_third_person.$error
              : null
          "
          :autocomplete="$lang.evidence_caption_third_person"
          :rows="this.$config.form.textareaRows"
        ></b-form-textarea>
        <b-form-invalid-feedback id="father_name-feedback">
          {{
            $lang.error_required | replace($lang.evidence_caption_third_person)
          }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        v-if="valueIndicator === `مثبت`"
        :label="$lang.evidence_caption_imperative"
        label-for="evidence"
        :label-cols="this.$config.form.labelCol"
      >
        <requiredComponent
          slot="label"
          :label="$lang.evidence_caption_imperative"
          :rules="$v.evidence_caption_imperative.$params"
        />
        <b-form-textarea
          id="evidence"
          type="text"
          v-model="$v.evidence_caption_imperative.$model"
          :state="
            $v.evidence_caption_imperative.$dirty
              ? !$v.evidence_caption_imperative.$error
              : null
          "
          :autocomplete="$lang.evidence_caption_imperative"
          :rows="this.$config.form.textareaRows"
        ></b-form-textarea>
        <b-form-invalid-feedback id="father_name-feedback">
          {{
            $lang.error_required | replace($lang.evidence_caption_imperative)
          }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-alert :show="viewMood === 'edit'" variant="info" class="mt-3">
        <i class="fas fa-info-circle fa-lg mr-1" />
        <b v-text="$lang.evidence_quality_helper" />
      </b-alert>
      <b-form-group
        v-if="viewMood === 'edit'"
        :label="$lang.quality"
        :label-cols="12"
      >
        <requiredComponent
          slot="label"
          :label="$lang.quality"
          :rules="$v.status.$params"
        />

        <b-form-radio-group
          :autocomplete="$lang.status"
          v-model="$v.status.$model"
          :options="status_options"
          :state="$v.status.$dirty ? !$v.status.$error : null"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-outline"
        ></b-form-radio-group>
      </b-form-group>
      <div class="float-right">
        <b-button
          class="ml-1"
          variant="success"
          v-if="viewMood == `edit`"
          :disabled="isLoading"
          @click="editEvidance()"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          class="ml-1"
          variant="success"
          v-if="viewMood == `add`"
          @click="addEvidance()"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button class="ml-1" variant="danger" @click="cancelEvidance">
          {{ $lang.cancelButton }}

          <i class="fa fa-ban"></i>
        </b-button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  name: "add-edit-evidence",
  validations: {
    evidence: {
      required,
    },
    status: {},
    evidence_caption_imperative: {
      required: requiredIf((vm) => vm.valueIndicator === "مثبت"),
    },
    evidence_caption_third_person: { required },
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    evidance_exercise_id: {
      type: Number,
      default: null,
    },
    viewMood: {
      type: String,
      default: "",
    },
    valueIndicator: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      evidence: null,
      status: 1,
      isLoading: false,
      evidence_caption_imperative: null,
      evidence_caption_third_person: null,
    };
  },
  computed: {
    status_options() {
      return renderEumOptions("evidence_level");
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    renderEumOptions,
    clear() {
      this.evidence = null;
      this.evidence_caption_imperative = null;
      this.evidence_caption_third_person = null;
      this.status = 1;
      this.$v.$reset();
    },
    async editEvidance() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.isLoading = true;
        const id = pathOr(null, ["id"], this.item);
        const url = generateApiUrl(["kanoon", "evidence_id"], [id]);
        const payload = {
          evidence: this.evidence,
          caption_imperative: this.evidence_caption_imperative,
          caption_third_person: this.evidence_caption_third_person,
          exercise_design_id: this.evidance_exercise_id,
          status: this.status,
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.clear();
        this.cancelEvidance();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async addEvidance() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "evidence"]);
        const payload = {
          evidence: this.evidence,
          caption_imperative: this.evidence_caption_imperative,
          caption_third_person: this.evidence_caption_third_person,
          exercise_design_id: this.evidance_exercise_id,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.clear();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    cancelEvidance() {
      this.$emit("modal-close", false);
    },
    async fetchData() {
      this.clear();
      try {
        this.isLoading = true;
        if (this.viewMood === "edit" && Object.keys(this.item).length) {
          this.evidence = pathOr(null, ["evidence"], this.item);
          this.evidence_caption_imperative = pathOr(
            null,
            ["caption_imperative"],
            this.item
          );
          this.evidence_caption_third_person = pathOr(
            null,
            ["caption_third_person"],
            this.item
          );
          const valStatus = this.status_options.find(
            (x) => x.value === pathOr(null, ["quality", "id"], this.item)
          );
          this.status = pathOr(null, ["value"], valStatus);
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
